import React from "react";
import { motion } from "framer-motion";
import { Sparkles, Moon } from "lucide-react";
import { Button } from "./ui/button";
import { FloatingHearts } from "./FloatingHearts";
import { PORTAL_HERO } from "../data/deck";

export const PortalLanding = ({ t, lang, onStart }) => {
  return (
    <div className="relative min-h-[calc(100vh-4rem)] overflow-hidden heart-nebula">
      {/* Hero gate + couple image */}
      <div className="absolute inset-0">
        <img src={PORTAL_HERO} alt="" className="w-full h-full object-cover opacity-90" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/10 to-[#2a0f18]" />
      </div>

      <FloatingHearts count={18} />

      <div className="relative z-10 flex flex-col items-center text-center px-5 pt-10 sm:pt-16 pb-20">
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="flex items-center gap-2 text-[#ffd9c2] mb-3"
        >
          <Sparkles className="w-4 h-4" />
          <span className="text-[11px] uppercase tracking-[0.35em]">
            {lang === "de" ? "Exklusive Liebeslegung" : "Exclusive Love Reading"}
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, delay: 0.2 }}
          className="font-portal-title rose-gold-text glow-rose text-6xl sm:text-7xl lg:text-8xl leading-tight"
        >
          Seelenpartnerschaft
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
          className="mt-5 max-w-md text-[#ffe9dc] text-base sm:text-lg leading-relaxed"
          style={{ textShadow: "0 2px 14px rgba(0,0,0,0.85)" }}
        >
          {lang === "de"
            ? "Tritt durch das Tor der Liebe – eine warmherzige, intuitive Legung für Seelenpartner, Dualseelen und Herzverbindungen."
            : "Step through the gate of love – a warm, intuitive reading for soulmates, twin flames and heart connections."}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1 }}
          className="pt-[40vh] sm:pt-[46vh]"
        >
          <div className="inline-block rounded-full px-2 py-2 bg-black/35 backdrop-blur-md border border-white/10">
            <Button
              data-testid="start-reading-btn"
              onClick={onStart}
              className="font-ornate bg-gradient-to-r from-[#f7c873] via-[#ffb6a0] to-[#ff8fa3] text-[#3d1020] font-bold hover:scale-[1.03] transition-transform rounded-full px-10 py-7 text-base sm:text-lg tracking-wide shadow-[0_8px_40px_rgba(255,120,110,0.7)] border-2 border-white/60"
            >
              {t.start_btn}
            </Button>
          </div>
          <p className="flex items-center justify-center gap-2 text-xs text-[#ffe9dc] mt-5" style={{ textShadow: "0 2px 10px rgba(0,0,0,0.9)" }}>
            <Moon className="w-3.5 h-3.5" />
            {t.hero_note}
          </p>
        </motion.div>
      </div>
    </div>
  );
};
